import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, HashRouter as Router, Routes as Switch } from 'react-router-dom';

import { StringKeyValue } from './actions/types';
import ErrorMessage from './components/Messages/ErrorMessage';
import CardApplication from './containers/CardApplication';
import Signing from './containers/Signing';
import { AppState } from './reducers';

interface Props {
    text: StringKeyValue;
}

class Routes extends Component<Props> {
    render() {
        const { text } = this.props;
        return (
            <Router>
                <Switch>
                    <Route path="/" element={<CardApplication />} />
                    <Route path="/velg-signering" element={<Signing />} />
                    {/* 404 - Page: Catch all undefined routes */}
                    <Route
                        path="*"
                        element={
                            <ErrorMessage
                                title={text.pageNotFoundTitle}
                                textList={[text.pageNotFoundText1, text.pageNotFoundText2, text.pageNotFoundText3]}
                                infoBox={text.defaultInfoBoxText}
                            />
                        }
                    />
                </Switch>
            </Router>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
});

export default connect(mapStateToProps)(Routes);
